import './Footer.scss'
import React from 'react'
import IonIcon from './IonIcon'
import bookImg from '../assets/book.jpg'
import { BOOK_LINK } from '../constants'

const SocialLink = ({ href, icon }) => {
  return (
    <a href={href}><IonIcon icon={icon} /></a>
  )
}

const Footer = () => {
  return (
    <footer className='Footer'>
      <div className='Footer_wrapper'>
        <div className='Footer_brand'>
          <h5>Unstuck Assessment</h5>
          <span>© {new Date().getFullYear()} Tony Morgan</span>
        </div>
        <ul className='Footer_social'>
          <li><SocialLink target='_blank' href='https://www.facebook.com/TheUnstuckGroup' icon='social-facebook' /></li>
          <li><SocialLink target='_blank' href='https://www.twitter.com/unstuckgroup' icon='social-twitter' /></li>
          <li><SocialLink target='_blank' href='https://www.linkedin.com/company/2547294' icon='social-linkedin' /></li>
        </ul>
      </div>
      <div className='Footer_promo'>
        <img src={bookImg} alt='The Unstuck Church: Equipping Churches to Experience Sustained Health' />
        <p>Learn more about all seven phases in the life cycle of a typical church in <a target='_blank' href={BOOK_LINK}>The Unstuck Church: Equipping Churches to Experience Sustained Health</a> by <a target='_blank' href='https://tonymorganlive.com/about/'>Tony Morgan</a>.</p>
      </div>
    </footer>
  )
}

Footer.displayName = 'Footer'

export default Footer



// WEBPACK FOOTER //
// ./src/lib/Footer.js